<template>
    <div class="largura-item">
        <div class="item">
            <div class="titulo titulo-protesto">
                <router-link tag="a" to="#" @click.native="carregarConsultaItem()" v-b-tooltip.hover v-b-tooltip="tooltip">{{ titulo }}</router-link>
            </div>
            <div class="passo passo-protesto passo_inativo mx-auto">
                <router-link tag="a" to="#" @click.native="carregarConsultaItem()">
                    <b-img :src="'images/icones/dashboard-protesto/' + item + '.png'" fluid alt="" v-b-tooltip.hover v-b-tooltip="tooltip"></b-img>
                </router-link>
            </div>

            <template v-if="quantidade != null">
                <div class="quantidade">
                    CDA's: {{quantidade}}
                </div>
            </template>
            <template v-else>
                <div class="quantidade">
                    CDA´s: Carregando..
                </div>
            </template>

            <template v-if="porcentagem != null">
                <div class="quantidade">
                    {{porcentagem}} %
                </div>
            </template>
            <template v-else>
                <div class="quantidade">
                    Carregando..
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: ["titulo", "tooltip", "icone", "quantidadeTotal", "item", "ano", "mes", "size"],
        data() {
            return {
                quantidade: null,
                porcentagem: null
            }
        },
        methods: {
            carregarConsultaItem() {
                if(this.quantidade != null && this.quantidade > 0) {
                    localStorage.setItem('tipoAcompanhamentoProtesto', this.item);
                    this.$router.push('/acompanhamento-protesto/consultar');
                }
            },
            async consultarQuantidade() {
                if (this.ano == null || this.mes == null) {
                    return;
                }

                this.resultado = [];

                const consulta = {
                    ano: this.ano,
                    mes: this.mes,
                    dashboardProtestoTipo: this.item
                };

                if(this.item == 0) {
                    consulta.retornoConfirmacaoPresente = true;
                    consulta.dataAptPresente = false;
                } else if(this.item == 1) {
                    consulta.retornoSolucaoPresente = true;
                    consulta.dataAptPresente = true;
                    consulta.statusProtesto = [2,3,4,5,6,9,10];
                    consulta.cartaPresente = false;
                } else if(this.item == 2) {
                    consulta.tipoCarta = [0,2];
                } else if(this.item == 3) {
                    consulta.retornoConfirmacaoPresente = true;
                    consulta.dataAptPresente = true;
                    consulta.statusProtesto = [13,14];
                    consulta.cartaPresente = false;
                } else if(this.item == 4) {
                    consulta.dataProtocoloPresente = false;
                    consulta.statusProtesto = [1];
                    consulta.cartaPresente = false;
                } else if(this.item == 5) {
                    consulta.dataAptPresente = true;
                    consulta.dataProtocoloPresente = true;
                    consulta.cartaPresente = false;
                    consulta.retornoSolucaoPresente = false;
                } else if(this.item == 6) {
                    consulta.retornoSolucaoPresente = true;
                    consulta.dataPagamentoParcelamentoPresente = false;
                    consulta.statusProtesto = [8];
                    consulta.cartaPresente = false;
                } else if(this.item == 8) {
                    consulta.retornoSolucaoPresente = true;
                    consulta.dataPagamentoParcelamentoPresente = true;
                    consulta.dataAptPresente = true;
                    consulta.ocorrencia = '1';
                    consulta.statusProtesto = [7];
                    consulta.cartaPresente = false;
                } else if(this.item == 9) {
                    consulta.dataPagamentoParcelamentoPresente = false;
                    consulta.dataAptPresente = true;
                    consulta.statusProtesto = [0,1,2,3,4,5,6,7,9,10,11,12,13,14];
                    consulta.ocorrencia = '1';
                    consulta.cartaPresente = false;
                } else if(this.item == 10) {
                    consulta.dataPagamentoParcelamentoPresente = true;
                    consulta.statusProtesto = [8,10,11];
                    consulta.tipoCarta = [1];
                } else if(this.item == 7 || this.item == 11) {
                    consulta.retornoSolucaoPresente = true;
                    consulta.dataPagamentoParcelamentoPresente = true;
                    consulta.statusProtesto = [8];
                    consulta.cartaPresente = false;
                }

                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;
                axios.post(`${urlApi}/v1/dashboardProtesto/obterTotal`, consulta, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }).then(response => {
                    this.quantidade = response.data;
                    this.calcularQuantidadeTotal();
                });
            },
            calcularQuantidadeTotal() {
                if(this.quantidadeTotal == 0 && this.quantidade == 0) {
                    this.porcentagem = 0;
                } else if(this.quantidadeTotal != '...' && this.quantidade != null) {
                    this.porcentagem = (this.quantidade * 100) / this.quantidadeTotal;
                    this.porcentagem = (Math.round(this.porcentagem * 100) / 100).toFixed(2).toString().replace(".", ",");
                } else {
                    this.porcentagem = null;
                }
            }
        },
        watch: {
            mes: function () {
                this.quantidade = null;
                this.consultarQuantidade();
            },
            ano: function () {
                this.quantidade = null;
                this.consultarQuantidade();
            },
            quantidadeTotal: function () {
                this.calcularQuantidadeTotal();
            }
        }
    };
</script>

<style>
    .passo-protesto {
        padding: 0 !important;
        height: 72px !important;
        width: 72px !important;
    }
    .titulo-protesto {
        height: 41px !important;
    }

    .largura-item {
        width: 21% !important;
    }
</style>


